import { styled } from '@material-ui/core';

export const BodyContainer = styled('div')({
	width: '100%',
	maxWidth: '100%',
	height: 'auto',
	borderRadius: 5,
	background: 'var(--color-bg-primary)',
	padding: 20,
	boxSizing: 'border-box',
	display: 'flex',
	flexWrap: 'wrap',
	alignItems: 'stretch',
	justifyContent: 'space-between',
});

export const StatusSection = styled('div')({
	'width': '90%',
	'maxWidth': '850px',
	'height': 'auto',
	'padding': 60,
	'marginTop': 30,
	'boxSizing': 'border-box',
	'borderRadius': 5,
	'margin': 'auto',
	'boxShadow': 'var(--shadow-lg)',
	'backgroundColor': 'var(--color-bg-elevated)',
	'display': 'flex',
	'flexDirection': 'column',
	'gap': 30,

	'& img': {
		maxWidth: '300px',
		maxHeight: '200px',
		objectFit: 'cover',
		textAlign: 'center',
		margin: 'auto',
	},

	'& button': {
		width: 'max-content',
		textAlign: 'center',
		margin: 'auto',
	},
});

export const StatusHeaderSection = styled('div')({
	'display': 'flex',
	'flexDirection': 'column',
	'gap': '0.5rem',
	'textAlign': 'center',

	'& h3': {
		fontSize: 25,
		color: 'var(--color-text-primary)',
		marginBottom: 0,
	},

	'& p': {
		color: 'var(--color-text-tertiary)',
		fontSize: 14,
		lineHeight: 2,
		maxWidth: '400px',
		margin: 'auto',
	},
	'& span': {
		color: 'var(--color-text-secondary)',
		fontSize: 12,
	},
});
